var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconZoomOut48Filled = function SvgIconZoomOut48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m38.35 35.94-7-7a12.26 12.26 0 1 0-2.41 2.41l7 7 2.41-2.41Zm-10.7-12.59h-12v-3.4h12v3.4Z",
    fill: "current"
  })));
};
export default SvgIconZoomOut48Filled;